import { useContext } from 'react';
import { agentUserContext } from 'application/contexts/useAgentUser';
import { useLoading } from 'application/contexts/useLoading';

export const useMatchList = () => {
    const { loading } = useLoading();
    const { matchList } = useContext(agentUserContext);

    return {
        loading,
        matchList,
    };
};
